import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CustomerData } from '@models/customers/customer-data.model';

import { environment } from 'environments/environment';

import { Observable } from 'rxjs';
import { ClientResponsible } from '@app/shared/models/customers/client-responsible.model';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  static readonly API_CUSTOMERS_BASE_PATH = `${environment.api.rest.customers}`;

  constructor(private http: HttpClient) {
  }

  loadCustomers(): Observable<CustomerData> {
    return this.http.get<CustomerData>(`${CustomersService.API_CUSTOMERS_BASE_PATH}`);
  }

  loadCustomer(id: string): Observable<CustomerData> {
    return this.http.get<CustomerData>(`${CustomersService.API_CUSTOMERS_BASE_PATH}/${id}`);
  }

  loadCustomerResponsibles(id: string): Observable<ClientResponsible[]> {
    return this.http.get<ClientResponsible[]>(`${CustomersService.API_CUSTOMERS_BASE_PATH}/${id}/responsibles`);
  }
}
